<template>
    <div class="pagination-bar">
        <button @click="prev" :disabled="getPrevDisabled" class="btn-icon icon-arrow-down btn-prev"></button>

        <div>{{ getText }}</div>

        <v-select :items="this.availableRowsPerPage" :value="this.rowsPerPage" @change="rowsPerPageUpdate" class="sr-select">
            <template #selection="{item}"> {{ item }} pro Seite</template>
        </v-select>

        <button @click="next" :disabled="getNextDisabled" class="btn-icon icon-arrow-down btn-next"></button>
    </div>
</template>

<script>
  export default {
    props: ['length', 'value'],
    data () {
      return {
        availableRowsPerPage: [
          10,
          25,
          50
        ]
      }
    },
    mounted () {
    },
    methods: {
      next () {
        this.page++
      },
      prev () {
        if (this.page > 1) {
          this.page--
        }
      },
      rowsPerPageUpdate (val) {
        this.rowsPerPage = val
      }
    },
    computed: {
      rowsPerPage: {
        get () {
          return this.value.rowsPerPage
        },
        set (newVal) {
          this.$emit('input', { page: this.page, rowsPerPage: newVal })
        }
      },
      page: {
        get () {
          return this.value.page
        },
        set (newVal) {
          this.$emit('input', { page: newVal, rowsPerPage: this.rowsPerPage })
        }
      },
      getText () {
        if (this.length === 0) {
          return ''
        }
        return ((this.rowsPerPage * (this.page - 1)) + 1) + '-' + ((this.rowsPerPage * this.page) > this.length ? this.length : (this.rowsPerPage * this.page)) + ' von ' + this.length
      },
      getNextDisabled () {
        if (this.page * this.rowsPerPage >= this.length) {
          return true
        }

        return false
      },
      getPrevDisabled () {
        if (this.page <= 1) {
          return true
        }
        return false
      }
    }
  }
</script>

<style scoped>
    .paginationSelect {
        width: 100px;
    }
</style>
